// Menu Copilot UI texts (Arabic / English). Facts inside messages and
// previews come from the backend; this file only labels them.

const AR = {
  title: "مساعد قائمة الطعام",
  open: "مساعد قائمة الطعام",
  subtitle: (menu) => `يعمل على: ${menu}`,
  close: "إغلاق",
  newChat: "محادثة جديدة",
  history: "المحادثات السابقة",
  noHistory: "لا توجد محادثات سابقة لهذه القائمة.",
  untitled: "محادثة بدون عنوان",
  placeholder: "اسأل عن قائمة الطعام أو اطلب تعديلاً…",
  send: "إرسال",
  thinking: "يفكر…",
  intro: "اسألني عن قائمة الطعام، أو اطلب تعديلاً. لن يتغير أي شيء قبل أن تراجع التغييرات وتضغط تطبيق.",
  tryAsking: "جرّب:",
  disabled: "المساعد غير مفعّل على الخادم. يمكنك متابعة تعديل قائمة الطعام يدوياً.",
  readOnlyNote: "صلاحيتك للعرض فقط: يمكنك السؤال دون إجراء تغييرات.",
  loadFailed: "تعذر تحميل المحادثة.",
  results: (n) => `${n} نتيجة`,
  showMore: (n) => `عرض الكل (${n})`,
  showLess: "عرض أقل",
  pickOne: "اختر واحداً:",
  // plan card
  changesPrepared: (n) => (n === 1 ? "تغيير واحد جاهز" : `${n} تغييرات جاهزة`),
  applyAll: (n) => (n > 1 ? `تطبيق الكل (${n})` : "تطبيق"),
  cancel: "إلغاء",
  edit: "تعديل",
  save: "حفظ التعديل",
  discard: "تراجع عن التعديل",
  remove: "إزالة هذا التغيير",
  undo: "تراجع",
  viewChanges: "عرض التغييرات",
  hideChanges: "إخفاء التغييرات",
  viewAffected: (n) => `عرض الأصناف المتأثرة (${n})`,
  hideAffected: "إخفاء الأصناف المتأثرة",
  affected: (n) => `${n} متأثر`,
  skipped: (n) => `تم تخطي ${n}`,
  exclude: "استبعاد",
  include: "إعادة",
  excluded: "مستبعد",
  verifyEstimates: "راجعت تقديرات الذكاء الاصطناعي (السعرات/مسببات الحساسية) وأؤكد صحتها.",
  verifyCalories: "تحققت من معلومات السعرات الحرارية",
  verifyAllergens: "تحققت من معلومات مسببات الحساسية",
  verifyWhy: "هذه تقديرات من الذكاء الاصطناعي وليست معلومات مؤكدة. عدّل القيم عند الحاجة ثم أكّد أنك تحققت منها قبل التطبيق.",
  verifyAllergenWarning: "تحقق من المكونات أو الوصفة الفعلية.",
  aiSuggestion: "اقتراح الذكاء الاصطناعي",
  needsVerification: "بحاجة للتحقق",
  userVerified: "تم التحقق من المستخدم",
  userEdited: "عدّله المستخدم",
  likelyAllergens: "مسببات الحساسية المحتملة",
  possibleAllergens: "قد يحتوي على",
  kcal: "سعرة",
  dependsOn: (list) => `يعتمد على التغيير ${list}`,
  regenerate: "إعادة إنشاء الاقتراح",
  expiredNote: "انتهت صلاحية هذا الاقتراح لأن قائمة الطعام ربما تغيرت منذ إعداده. أعد إنشاءه لمراجعة التغييرات على القائمة الحالية.",
  regeneratedTo: "تم إنشاء اقتراح جديد أدناه.",
  attachImage: "إرفاق صورة (1024×700)",
  replaceImage: "استبدال الصورة",
  imageAttached: "الصورة جاهزة، وستُطبق عند التأكيد.",
  rolledBackNote: "تعذر إكمال التغييرات فتم التراجع عن كل ما طُبّق. لم يتغير شيء.",
  blockedNote: "بعض التغييرات تحتاج تعديلاً أو إزالة قبل التطبيق.",
  staleNote: "تغيرت قائمة الطعام منذ المعاينة. هذه المعاينة المحدّثة — راجعها ثم طبّق.",
  expiresNote: "تنتهي صلاحية هذا الاقتراح بعد 30 دقيقة.",
  aiGenerated: "مقترح بالذكاء الاصطناعي",
  verified: "تم التحقق",
  before: "قبل",
  after: "بعد",
  lifecycle: { draft: "مسودة", active: "مفعّلة", archived: "مؤرشفة" },
  allergens: { gluten: "جلوتين", dairy: "ألبان", eggs: "بيض", tree_nuts: "مكسرات", peanuts: "فول سوداني", soy: "صويا", fish: "سمك", crustaceans: "قشريات", molluscs: "رخويات", sesame: "سمسم", mustard: "خردل", celery: "كرفس", sulphites: "كبريتيت", lupin: "ترمس" },
  status: { pending: "بانتظار التأكيد", executing: "جاري التطبيق", completed: "تم التطبيق", partially_completed: "تطبيق جزئي", failed: "فشل", cancelled: "ملغي", superseded: "تم استبداله", expired: "منتهي الصلاحية" },
  undone: "تم التراجع",
  appliedNote: (n) => `تم تطبيق ${n} تغيير بنجاح.`,
  partialNote: "تم تطبيق جزء فقط من التغييرات. التفاصيل:",
  failedNote: "لم يتم تطبيق أي تغيير.",
  undoUnavailable: "لا يمكن التراجع عن هذه التغييرات تلقائياً.",
  undoConflict: "تغيرت البيانات بعد التطبيق، لذلك لا يمكن التراجع تلقائياً.",
  stepDone: "تم",
  stepFailed: "فشل",
  stages: { addition_create: "إنشاء الإضافات", menu: "تعديلات قائمة الطعام", addition_after: "تعديل الإضافات", copy: "النسخ" },
  ops: {
    CREATE_SECTION: "قسم جديد",
    RENAME_SECTION: "تعديل اسم قسم",
    DELETE_SECTION: "حذف قسم",
    CREATE_ITEM: "صنف جديد",
    UPDATE_ITEM: "تعديل صنف",
    DELETE_ITEMS: "حذف أصناف",
    MOVE_ITEMS: "نقل أصناف",
    CHANGE_PRICES: "تغيير الأسعار",
    ADD_DISCOUNT: "خصم",
    REMOVE_DISCOUNT: "إزالة خصم",
    GENERATE_CONTENT: "محتوى مقترح",
    CREATE_ADDITION: "إضافة جديدة",
    UPDATE_ADDITION: "تعديل إضافة",
    DELETE_ADDITIONS: "حذف إضافات",
    LINK_ADDITION: "ربط إضافة",
    UNLINK_ADDITION: "فصل إضافة",
    COPY_SECTION: "نسخ قسم",
    COPY_ITEMS: "نسخ أصناف",
    MOVE_ADDITION_LINKS: "نقل إضافة",
    LINK_ADDITION_IN_MENU: "ربط إضافة",
    UNLINK_ADDITION_IN_MENU: "فصل إضافة",
    ACTIVATE_MENU: "تفعيل قائمة الطعام",
    ARCHIVE_MENU: "أرشفة قائمة الطعام",
    RESTORE_MENU: "استعادة قائمة الطعام",
    ASSIGN_BRANCHES: "إضافة فروع",
    UNASSIGN_BRANCHES: "إزالة فروع",
    SET_BRANCHES: "تحديد الفروع",
    REMOVE_IMAGE: "إزالة صورة",
    SET_IMAGE: "صورة الصنف",
    REORDER_ITEM: "ترتيب صنف",
    REORDER_SECTION: "ترتيب قسم",
  },
  fields: {
    lifecycle: "الحالة",
    sections: "الأقسام",
    items: "الأصناف",
    order: "الترتيب",
    image: "الصورة",
    menu: "قائمة الطعام",
    copiedAdditions: "الإضافات المنسوخة معها",
    name: "الاسم",
    section: "القسم",
    price: "السعر",
    description: "الوصف",
    calories: "السعرات",
    destinationSection: "إلى قسم",
    priceChangeMode: "طريقة التغيير",
    priceChangeValue: "القيمة",
    pricingName: "اسم السعر",
    pricingNames: "الأسعار",
    discountType: "النوع",
    discountValue: "الخصم",
    replaceExisting: "استبدال الخصومات الحالية",
    contentField: "المحتوى",
    contentLanguage: "اللغة",
    contentMode: "الطريقة",
    additionTitle: "اسم الإضافة",
    options: "الخيارات",
    min: "الحد الأدنى",
    max: "الحد الأقصى",
    isMandatory: "إلزامية",
    addition: "الإضافة",
    source: "من",
    destination: "إلى",
    crossRestaurant: "بين مطعمين",
    nameAr: "الاسم بالعربية",
    nameEn: "الاسم بالإنجليزية",
    descriptionAr: "الوصف بالعربية",
    descriptionEn: "الوصف بالإنجليزية",
  },
  values: {
    percentage: "نسبة مئوية",
    amount: "مبلغ ثابت",
    set: "تحديد سعر",
    increase_amount: "زيادة بمبلغ",
    decrease_amount: "تخفيض بمبلغ",
    increase_percent: "زيادة بنسبة",
    decrease_percent: "تخفيض بنسبة",
    description: "الوصف",
    name_translation: "ترجمة الاسم",
    calories: "السعرات",
    allergens: "مسببات الحساسية",
    ar: "العربية",
    en: "الإنجليزية",
    both: "العربية والإنجليزية",
    fill_missing: "إكمال الناقص",
    rewrite: "إعادة صياغة",
    yes: "نعم",
    no: "لا",
    linked: "مرتبطة",
    notLinked: "غير مرتبطة",
    deleted: "محذوف",
    usedBy: (n) => `مستخدمة في ${n} صنف`,
    assigned: "مرتبط",
    notAssigned: "غير مرتبط",
    noImage: "بدون صورة",
    hasImage: "صورة",
  },
  reasons: {
    already_assigned: "مرتبط بالفعل",
    not_assigned: "غير مرتبط",
    no_image: "بدون صورة",
    already_in_section: "موجود في القسم بالفعل",
    no_price: "بدون سعر",
    no_pricing_entry: "لا يوجد هذا السعر",
    negative_price: "السعر سيصبح سالباً",
    unchanged: "بدون تغيير",
    discount_exceeds_price: "الخصم أكبر من السعر",
    already_discounted: "عليه خصم مختلف",
    no_discount: "لا يوجد خصم",
    different_discount: "خصم مختلف",
    no_suggestion: "لا يوجد اقتراح",
    already_filled: "موجود بالفعل",
    already_linked: "مرتبطة بالفعل",
    not_linked: "غير مرتبطة",
  },
  errors: {
    RATE_LIMITED: "رسائل كثيرة خلال وقت قصير. انتظر قليلاً ثم حاول.",
    REQUEST_IN_PROGRESS: "هذه الرسالة قيد المعالجة. انتظر لحظة ثم حاول مرة أخرى.",
    PLAN_STALE: "تغيرت قائمة الطعام منذ المعاينة. راجع المعاينة المحدّثة.",
    PLAN_CHANGED: "تغير الاقتراح. حدّث الصفحة وحاول مرة أخرى.",
    PLAN_EXPIRED: "انتهت صلاحية الاقتراح لأن قائمة الطعام ربما تغيرت. أعد إنشاءه.",
    PLAN_BLOCKED: "بعض التغييرات لا يمكن تطبيقها بعد.",
    PLAN_IN_PROGRESS: "يتم تطبيق هذه التغييرات الآن.",
    PLAN_NOT_PENDING: "لم يعد هذا الاقتراح بانتظار التأكيد.",
    VERIFICATION_REQUIRED: "أكد مراجعة التقديرات قبل التطبيق.",
    UNDO_CONFLICT: "تغيرت البيانات بعد التطبيق، لذلك لا يمكن التراجع تلقائياً.",
    UNDO_UNAVAILABLE: "لا يمكن التراجع عن هذه التغييرات.",
    CLARIFICATION_EXPIRED: "لم يعد هذا الاختيار متاحاً. أعد الطلب.",
    OPERATION_HAS_DEPENDENTS: "تغييرات أخرى تعتمد على هذا التغيير. أزلها أولاً.",
    COPILOT_LIMITS_UNAVAILABLE: "المساعد غير متاح مؤقتاً. يمكنك متابعة تعديل قائمة الطعام يدوياً.",
    PLAN_NOT_EXPIRED: "هذا الاقتراح ما زال صالحاً.",
  },
};

const EN = {
  title: "Menu Copilot",
  open: "Menu Copilot",
  subtitle: (menu) => `Working on: ${menu}`,
  close: "Close",
  newChat: "New chat",
  history: "Previous chats",
  noHistory: "No previous chats for this menu.",
  untitled: "Untitled chat",
  placeholder: "Ask about this menu or request a change…",
  send: "Send",
  thinking: "Thinking…",
  intro: "Ask me about this menu, or ask for a change. Nothing changes until you review the changes and press Apply.",
  tryAsking: "Try:",
  disabled: "The Copilot is not enabled on the server. You can keep editing the menu manually.",
  readOnlyNote: "Your role is view-only: you can ask questions but not make changes.",
  loadFailed: "Could not load the chat.",
  results: (n) => `${n} result(s)`,
  showMore: (n) => `Show all (${n})`,
  showLess: "Show less",
  pickOne: "Pick one:",
  changesPrepared: (n) => (n === 1 ? "1 change prepared" : `${n} changes prepared`),
  applyAll: (n) => (n > 1 ? `Apply all ${n}` : "Apply"),
  cancel: "Cancel",
  edit: "Edit",
  save: "Save changes",
  discard: "Discard edits",
  remove: "Remove this change",
  undo: "Undo",
  viewChanges: "View changes",
  hideChanges: "Hide changes",
  viewAffected: (n) => `View affected items (${n})`,
  hideAffected: "Hide affected items",
  affected: (n) => `${n} affected`,
  skipped: (n) => `${n} skipped`,
  exclude: "Exclude",
  include: "Include",
  excluded: "Excluded",
  verifyEstimates: "I reviewed the AI estimates (calories/allergens) and confirm they are correct.",
  verifyCalories: "I verified this calorie information",
  verifyAllergens: "I verified the allergen information",
  verifyWhy: "These are AI estimates, not verified facts. Edit the values if needed, then confirm you verified them before applying.",
  verifyAllergenWarning: "Verify against the actual ingredients/recipe.",
  aiSuggestion: "AI suggestion",
  needsVerification: "Needs verification",
  userVerified: "User verified",
  userEdited: "Edited by you",
  likelyAllergens: "Likely allergens",
  possibleAllergens: "May contain",
  kcal: "kcal",
  dependsOn: (list) => `Depends on change ${list}`,
  regenerate: "Regenerate proposal",
  expiredNote: "This proposal expired because the menu may have changed since it was prepared. Regenerate it to review the changes on the current menu.",
  regeneratedTo: "A new proposal was prepared below.",
  attachImage: "Attach image (1024×700)",
  replaceImage: "Replace image",
  imageAttached: "Image ready; it is applied when you confirm.",
  rolledBackNote: "The changes could not be completed, so everything applied was rolled back. Nothing changed.",
  blockedNote: "Some changes need to be edited or removed before applying.",
  staleNote: "The menu changed since the preview. This is the updated preview — review it, then apply.",
  expiresNote: "This proposal expires after 30 minutes.",
  aiGenerated: "AI suggested",
  verified: "Verified",
  before: "Before",
  after: "After",
  lifecycle: { draft: "Draft", active: "Active", archived: "Archived" },
  allergens: { gluten: "Gluten", dairy: "Dairy", eggs: "Eggs", tree_nuts: "Tree nuts", peanuts: "Peanuts", soy: "Soy", fish: "Fish", crustaceans: "Crustaceans", molluscs: "Molluscs", sesame: "Sesame", mustard: "Mustard", celery: "Celery", sulphites: "Sulphites", lupin: "Lupin" },
  status: { pending: "Awaiting confirmation", executing: "Applying", completed: "Applied", partially_completed: "Partially applied", failed: "Failed", cancelled: "Cancelled", superseded: "Replaced", expired: "Expired" },
  undone: "Undone",
  appliedNote: (n) => `${n} change(s) applied successfully.`,
  partialNote: "Only part of the changes were applied. Details:",
  failedNote: "No change was applied.",
  undoUnavailable: "These changes cannot be undone automatically.",
  undoConflict: "The data changed after applying, so this cannot be undone automatically.",
  stepDone: "Done",
  stepFailed: "Failed",
  stages: { addition_create: "Create additions", menu: "Menu changes", addition_after: "Addition changes", copy: "Copies" },
  ops: {
    CREATE_SECTION: "New section",
    RENAME_SECTION: "Rename section",
    DELETE_SECTION: "Delete section",
    CREATE_ITEM: "New item",
    UPDATE_ITEM: "Update item",
    DELETE_ITEMS: "Delete items",
    MOVE_ITEMS: "Move items",
    CHANGE_PRICES: "Price change",
    ADD_DISCOUNT: "Discount",
    REMOVE_DISCOUNT: "Remove discount",
    GENERATE_CONTENT: "Suggested content",
    CREATE_ADDITION: "New addition",
    UPDATE_ADDITION: "Update addition",
    DELETE_ADDITIONS: "Delete additions",
    LINK_ADDITION: "Link addition",
    UNLINK_ADDITION: "Unlink addition",
    COPY_SECTION: "Copy section",
    COPY_ITEMS: "Copy items",
    MOVE_ADDITION_LINKS: "Move addition",
    LINK_ADDITION_IN_MENU: "Link addition",
    UNLINK_ADDITION_IN_MENU: "Unlink addition",
    ACTIVATE_MENU: "Activate menu",
    ARCHIVE_MENU: "Archive menu",
    RESTORE_MENU: "Restore menu",
    ASSIGN_BRANCHES: "Add branches",
    UNASSIGN_BRANCHES: "Remove branches",
    SET_BRANCHES: "Set branches",
    REMOVE_IMAGE: "Remove image",
    SET_IMAGE: "Item image",
    REORDER_ITEM: "Reorder item",
    REORDER_SECTION: "Reorder section",
  },
  fields: {
    lifecycle: "Status",
    sections: "Sections",
    items: "Items",
    order: "Order",
    image: "Image",
    menu: "Menu",
    copiedAdditions: "Copied relationships",
    name: "Name",
    section: "Section",
    price: "Price",
    description: "Description",
    calories: "Calories",
    destinationSection: "To section",
    priceChangeMode: "Change",
    priceChangeValue: "Value",
    pricingName: "Price name",
    pricingNames: "Prices",
    discountType: "Type",
    discountValue: "Discount",
    replaceExisting: "Replace existing discounts",
    contentField: "Content",
    contentLanguage: "Language",
    contentMode: "Mode",
    additionTitle: "Addition",
    options: "Options",
    min: "Min",
    max: "Max",
    isMandatory: "Mandatory",
    addition: "Addition",
    source: "From",
    destination: "To",
    crossRestaurant: "Cross-restaurant",
    nameAr: "Arabic name",
    nameEn: "English name",
    descriptionAr: "Arabic description",
    descriptionEn: "English description",
  },
  values: {
    percentage: "Percentage",
    amount: "Fixed amount",
    set: "Set price",
    increase_amount: "Increase by amount",
    decrease_amount: "Decrease by amount",
    increase_percent: "Increase by %",
    decrease_percent: "Decrease by %",
    description: "Description",
    name_translation: "Name translation",
    calories: "Calories",
    allergens: "Allergens",
    ar: "Arabic",
    en: "English",
    both: "Arabic and English",
    fill_missing: "Fill missing",
    rewrite: "Rewrite",
    yes: "Yes",
    no: "No",
    linked: "Linked",
    notLinked: "Not linked",
    deleted: "Deleted",
    usedBy: (n) => `Used by ${n} item(s)`,
    assigned: "Assigned",
    notAssigned: "Not assigned",
    noImage: "No image",
    hasImage: "Image",
  },
  reasons: {
    already_assigned: "Already assigned",
    not_assigned: "Not assigned",
    no_image: "No image",
    already_in_section: "Already in this section",
    no_price: "No price",
    no_pricing_entry: "No such price",
    negative_price: "Price would be negative",
    unchanged: "Unchanged",
    discount_exceeds_price: "Discount above the price",
    already_discounted: "Has another discount",
    no_discount: "No discount",
    different_discount: "Different discount",
    no_suggestion: "No suggestion",
    already_filled: "Already filled",
    already_linked: "Already linked",
    not_linked: "Not linked",
  },
  errors: {
    RATE_LIMITED: "Too many messages in a short time. Wait a moment and try again.",
    REQUEST_IN_PROGRESS: "This message is still being processed. Wait a moment and try again.",
    PLAN_STALE: "The menu changed since the preview. Review the updated preview.",
    PLAN_CHANGED: "The proposal changed. Reload and try again.",
    PLAN_EXPIRED: "This proposal expired because the menu may have changed. Regenerate it.",
    PLAN_BLOCKED: "Some changes cannot be applied yet.",
    PLAN_IN_PROGRESS: "These changes are being applied right now.",
    PLAN_NOT_PENDING: "This proposal is no longer awaiting confirmation.",
    VERIFICATION_REQUIRED: "Confirm that you reviewed the estimates before applying.",
    UNDO_CONFLICT: "The data changed after applying, so this cannot be undone automatically.",
    UNDO_UNAVAILABLE: "These changes cannot be undone.",
    CLARIFICATION_EXPIRED: "That choice is no longer available. Ask again.",
    OPERATION_HAS_DEPENDENTS: "Other changes depend on this one. Remove them first.",
    COPILOT_LIMITS_UNAVAILABLE: "The Copilot is temporarily unavailable. You can keep editing the menu manually.",
    PLAN_NOT_EXPIRED: "This proposal is still valid.",
  },
};

export const copilotText = (lang) => (lang === "en" ? EN : AR);

export function copilotErrorMessage(error, t, fallback) {
  return t.errors[error?.code] || fallback || error?.message || "";
}
